"use client"

import { format } from "date-fns"
import { Calendar as CalendarIcon } from "lucide-react"

import { cn } from "../../lib/utils"
import { Button } from "./button"
import { Calendar } from "./calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "./popover"
import { vi } from "date-fns/locale"
import { SelectSingleEventHandler } from "react-day-picker"
import { Matcher } from "react-day-picker"

interface DatePickerProps {
  label?: string
  date?: Date
  onChange?: (date: Date | undefined) => void
  startDate?: Date
  endDate?: Date
}

export function DatePicker({ label, date, onChange, startDate, endDate }: DatePickerProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          variant={"outline"}
          className={cn(
            "w-[max-content] justify-start text-left font-normal overflow-scroll",
            !date && "text-muted-foreground"
          )}
          style={{
            scrollbarWidth: "none",
          }}
        >
          <CalendarIcon className="mr-2 h-4 w-4" />
          {date ? format(date, "PPP", { locale: vi }) : <span>{label || "Pick a date"}</span>}
        </Button>

      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 bg-white">
        <Calendar
          mode="single"
          selected={date}
          onSelect={onChange as SelectSingleEventHandler}
          initialFocus
          locale={vi}
          disabled={
            [
              startDate ? { before: startDate } : undefined,
              endDate ? { after: endDate } : undefined
            ].filter(Boolean) as Matcher[]
          }
          modifiersClassNames={{
            today: "bg-blue-500 text-white",
            selected: "bg-gray-400 text-white",
          }}
        />
      </PopoverContent>
    </Popover>
  )
}
